import { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { X, Check, QrCode } from 'lucide-react';

export default function QRCodeTool({ onGenerate, onClose }) {
  const [url, setUrl] = useState('');

  const handleGenerate = () => {
    if (!url.trim()) return;
    // Render QR code to canvas and extract as data URL
    const canvas = document.querySelector('[data-testid="qr-canvas"] canvas');
    if (canvas) {
      const dataUrl = canvas.toDataURL('image/png');
      onGenerate(dataUrl);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="qr-tool-modal" onClick={onClose}>
      <div className="bg-[#111111] border border-white/10 rounded-2xl max-w-sm w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div className="flex items-center gap-2">
            <QrCode className="w-4 h-4 text-[#00E5FF]" />
            <h3 className="font-['Outfit'] text-base font-bold text-white">Generate QR Code</h3>
          </div>
          <button onClick={onClose} data-testid="qr-close-btn" className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-500 hover:text-white hover:bg-white/10 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-slate-500 block mb-2">Enter URL</label>
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://yourbusiness.com"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#00E5FF]/50 focus:ring-1 focus:ring-[#00E5FF]/30 transition-all placeholder:text-slate-600"
              data-testid="qr-url-input"
              autoFocus
            />
          </div>

          {url.trim() && (
            <div className="flex justify-center p-4 bg-white rounded-xl" data-testid="qr-canvas">
              <QRCodeCanvas
                value={url}
                size={200}
                level="H"
                bgColor="#ffffff"
                fgColor="#000000"
                includeMargin={true}
              />
            </div>
          )}
        </div>

        <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-white/10">
          <button onClick={onClose} className="px-4 py-2.5 rounded-xl text-xs font-medium text-slate-400 border border-white/10 hover:text-white hover:border-white/20 transition-colors">
            Cancel
          </button>
          <button
            onClick={handleGenerate}
            disabled={!url.trim()}
            data-testid="qr-generate-btn"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-xs font-semibold bg-[#00E5FF] text-[#0A0A0A] hover:bg-white transition-colors disabled:opacity-50"
          >
            <Check className="w-3.5 h-3.5" /> Place on Product
          </button>
        </div>
      </div>
    </div>
  );
}
